import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { portfolioProjects } from "../data/portfolio";
import { ui } from "../data/ui";
import { requestService } from "../utils/serviceRequest";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
export function Portfolio() {
  const {
    t
  } = useLanguage();
  return <section id="portfolio" aria-labelledby="portfolio-title" className="bg-charcoal py-20 lg:py-28" data-id="element-301" data-mp="3hxgvaiqa0tjk">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-302" data-mp="3d0gr6dczm0v3">
        <SectionHeading id="portfolio-title" title={t(ui.portfolio.title)} subtitle={t(ui.portfolio.subtitle)} data-id="element-303" data-mp="388p80nw5uxez" />

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-304" data-mp="339vx9389dkii">
          {portfolioProjects.map((project, i) => <li key={project.id} data-id="element-305" data-mp="4jvp7girw81h" data-mpi={i}>
              <Reveal delay={i * 0.05} className="h-full" data-id="element-306" data-mp="4l6r1asnr5py">
                <article className="group relative flex h-full flex-col border border-white/10 bg-ink transition-[border-color] duration-200 ease-out hover:border-gold/50" data-id="element-307" data-mp="3vxrrm1acv0c4">
                  <img src={project.image} alt={t(project.alt)} loading="lazy" decoding="async" className="aspect-[7/6] w-full object-cover object-right" data-id="element-308" data-mp="mnw34vchtz1g" />
                  <div className="flex flex-1 flex-col p-6" data-id="element-309" data-mp="dtr3bmfdtd9s">
                    <span className="self-start rounded-sm bg-gold px-2.5 py-1 text-xs font-bold uppercase tracking-wider text-ink" data-id="element-310" data-mp="3v2nxa9kcz1lh">
                      {t(project.badge)}
                    </span>
                    <h3 className="mt-4 font-display text-xl font-bold leading-snug text-white" data-id="element-311" data-mp="3m42jerpu0ar1">{t(project.title)}</h3>
                    <a href="#contact" onClick={() => requestService(project.serviceType, t(project.badge))} aria-label={`${t(ui.services.learnMore)}: ${t(project.badge)}`} className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-semibold text-gold after:absolute after:inset-0 focus-visible:outline-none" data-id="element-312" data-mp="3r2nigntckodw">
                      <span className="link-slide" data-id="element-313" data-mp="1iwv38nhk1e3f">{t(ui.services.learnMore)}</span>
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-314" data-mp="1dvntwjzrk6un" />
                    </a>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}